module.exports = __webpack_public_path__ + "img/icon_1_8.dd0fc80a.png";